import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/campaigns");
    } catch (e) {
      setErr(formatErr(e.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" style={{ background: "var(--rahi-bg)" }}>
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden" style={{ background: "var(--rahi-ink)" }}>
        <div className="font-display text-2xl text-white font-black">RAHI<span style={{ color: "var(--rahi-red)" }}>·</span>mailer</div>
        <div>
          <div className="w-12 h-[3px] mb-8" style={{ background: "var(--rahi-red)" }} />
          <h1 className="font-display text-white font-black text-5xl leading-[1.05] tracking-tight mb-6">
            Crafted newsletters.<br/>Trusted delivery.
          </h1>
          <p className="text-[#A8A29E] text-base max-w-md leading-relaxed">
            The internal publishing tool for RAHI-feed — compose your quarterly impact story,
            then send to thousands with deliverability you can rely on.
          </p>
        </div>
        <div className="text-[#A8A29E] text-xs tracking-[0.2em] uppercase">
          Q1 FY 2026–27 &middot; Quarterly Impact Report
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={onSubmit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden font-display text-xl font-black mb-10">
            RAHI<span style={{ color: "var(--rahi-red)" }}>·</span>mailer
          </div>
          <p className="text-[11px] uppercase tracking-[0.2em] mb-2" style={{ color: "var(--rahi-red)" }}>Sign in</p>
          <h2 className="font-display text-3xl font-black mb-8 tracking-tight">Welcome back</h2>

          <div className="mb-4">
            <label className="label">Email</label>
            <input
              type="email" required autoFocus
              value={email} onChange={(e)=>setEmail(e.target.value)}
              className="input" placeholder="you@riseagainsthungerindia.org"
              data-testid="login-email-input"
            />
          </div>
          <div className="mb-6">
            <label className="label">Password</label>
            <input
              type="password" required
              value={password} onChange={(e)=>setPassword(e.target.value)}
              className="input"
              data-testid="login-password-input"
            />
          </div>

          {err && <div className="text-sm mb-4 p-3 rounded-md" style={{ background:"#FEF2F2", color:"#B91C1C" }} data-testid="login-error">{err}</div>}

          <button type="submit" disabled={loading} className="btn btn-primary w-full justify-center" data-testid="login-submit-btn">
            {loading ? "Signing in…" : "Sign in"}
          </button>

          <p className="hint mt-8 text-center">
            Admin access only. If you have forgotten your password, contact your administrator.
          </p>
        </form>
      </div>
    </div>
  );
}
